<script setup lang="ts">
import { useNotificationStore } from '@/store/notificationStore';
const store = useNotificationStore()
</script>

<template>
  <div class="notification-wrapper" :style="{ top: `${store.topPosition}px` }">
    <div class="notification">
      <div class="check-icon">
        <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="#1D9E75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="text-content">
        <div class="title">{{ store.message }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.notification-wrapper {
  position: fixed;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 120;
}
.notification {
  background: linear-gradient(160deg, #f7faf8 0%, #eef6f1 100%);
  border: 1px solid #d8ebe1;
  border-radius: 14px;
  padding: 14px 18px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  max-width: 520px;
  box-shadow: 0 4px 20px rgba(29, 158, 117, 0.12);
}
.check-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(29, 158, 117, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.text-content {
  flex: 1;
  min-width: 0;
  text-align: left;
}
.title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1a1a18;
}
</style>
